export default "__VITE_ASSET__aa8b3354__"